import axios from 'axios';

export const MAIN_SETTING_REQUEST = 'MAIN_SETTING_REQUEST';
export const MAIN_SETTING_SUCCESS = 'MAIN_SETTING_SUCCESS';
export const MAIN_SETTING_FAIL = 'MAIN_SETTING_FAIL';
export const BOARD_THEME_SET = 'BOARD_THEME_SET';

export const mainSettingRequest = () => {
    return {
      type: MAIN_SETTING_REQUEST
    }
  }
export const mainSettingSuccess = (columns, length, theme) => {
    return {
        type: MAIN_SETTING_SUCCESS,
        columns: columns,
        length: length,
        theme: theme,
    }
}

export const mainSettingFail = () => {
    return {
        type: MAIN_SETTING_FAIL
    }
}

export const themeUpdate = (theme) => {
    return {
        type: BOARD_THEME_SET,
        theme: theme === 0 ? 'normal' : 'excel',
    }
}

export const mainSettingUpdate = (data, userIdx) => {
    const all = ['logIdx', 'areaNo', 'areaNm', 'modelNo', 'wind', 'status', 'battery', 'rgstDt'];
    const tmp = all.reduce((result, item) => {
        result[item] = data.includes(item) ? 1 : 0;
        return result;
      }, {});
    return (dispatch) => {
        return axios.post('/api/userColumns/updateColumns', {
            userIdx: userIdx,
            ...tmp,
        })
        .then(response => {
            const data = response.data[0];
            const length = response.data[1];
            const keys = Object.keys(data);
            const columns = keys.filter((key) => data[key] === 1 && key !== 'userIdx' && key !== 'theme');
            const theme = data['theme'] === 1 ? 'excel' : 'normal';
            dispatch(mainSettingSuccess(columns, length, theme));
        })
        .catch(function (error){
            console.log(error);
        });
    }
}

export const mainSettingThemeUpdate = (userIdx) => {
    return (dispatch) => {
        return axios.post('/api/userColumns/updateTheme', {"userIdx": userIdx})
            .then(response => {
                dispatch(themeUpdate(response.data));
            })
            .catch(function (error) {
                console.log(error);
            })
    }
}

export const mainSettingManager = (userIdx) => {
    return (dispatch) => {
        dispatch(mainSettingRequest());
        return axios.get('/api/userColumns/getColumns', {params: {userIdx: userIdx}})
            .then(response => {
                const data = response.data[0];
                const length = response.data[1];
                const keys = Object.keys(data);
                const columns = keys.filter((key) => data[key] === 1 && key !== 'userIdx' && key !== 'theme');
                const theme = data['theme'] === 1 ? 'excel' : 'normal';
                dispatch(mainSettingSuccess(columns, length, theme));
            })
            .catch(function (error) {
                dispatch(mainSettingFail())
                console.log(error);
            });
    }
}

const initialState = {
    board: {
      columns: ['logIdx', 'modelNo', 'wind', 'status', 'battery', 'rgstDt'],
      length: 4,
      theme: 'excel',
    },
  };

export const mainSetting1 = (state = null, action) => {
    switch(action.type) {
        case 'MAIN_SETTING_REQUEST':
            return state;
        case 'MAIN_SETTING_SUCCESS':
            return {
                board: {
                    ...state.board,
                    columns: action.columns,
                    length: action.length,
                    theme: action.theme,
                }
            }
        case 'MAIN_SETTING_FAIL':
            return initialState;
        case 'BOARD_THEME_SET':
            return {
                board: {
                    ...state.board,
                    theme: action.theme,
                }
            }
        default:
            return state;
    }
};